<div class="row mt-1 me-2">
  <div class="col"></div>
  <div class="col-auto">
    <div class="opcion rounded-pill pointer ps-1 pe-1">
      <i class="fa-solid fa-magnifying-glass"></i>
    </div>
  </div>
  <div class="col-auto">
    <div class="opcion rounded-pill pointer ps-1 pe-1">
      <i class="fa-solid fa-power-off"></i>    
    </div>
  </div>
</div>